import { render, staticRenderFns } from "./WButton.vue?vue&type=template&id=80cf881e&scoped=true&"
import script from "./wButton.ts?vue&type=script&lang=ts&"
export * from "./wButton.ts?vue&type=script&lang=ts&"
import style0 from "./WButton.vue?vue&type=style&index=0&id=80cf881e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cf881e",
  null
  
)

export default component.exports